import { CustomerSalesOrder } from "pages/ClientPortal/ECommerce/components/Cart/components/CustomerSalesOrder";
import { useEffect } from "react";
import { SalesOrderForm } from "../SalesOrder/SalesOrderForm";

interface OrderFormProps {
  onHide?: (usenavigate?) => void;
  relod: () => void;
  jobId?: any;
  processId?: any;
  referenceId?: any;
  mode: any;
  step?: any;
  taskId?:any;
  Id?:any;
  rowObject?: any;
  handleShowReferenceStepper?: (referenceId: string) => void;
  buttonPrintObjCallBack?: (obj: any) => void;
  callAttachmentMoveTemp?:any
}



export const OrderForm = ({
  mode,
  relod,
  onHide,
  rowObject,
  handleShowReferenceStepper,
  buttonPrintObjCallBack,
  step,
  taskId,
  jobId,
  Id,
  processId,
  referenceId,
  callAttachmentMoveTemp
}: OrderFormProps) => {


  useEffect(() => {

    
  }, []);

  return (
    <div className=" ">
        {window.location.href.includes("cartable")||window.location.href.includes("jobs")||window.location.href.includes("customer-requests")?
        
        <SalesOrderForm 
          mode={mode}
          relod={relod}
          onHide={onHide}
          rowObject={rowObject}
          handleShowReferenceStepper={handleShowReferenceStepper}
          buttonPrintObjCallBack={buttonPrintObjCallBack}
          step={step}
          taskId={taskId}
          jobId={jobId}
          Id={Id}
          processId={processId}
          referenceId={referenceId}
          callAttachmentMoveTemp={callAttachmentMoveTemp}
         />
    
    :
    <CustomerSalesOrder 
        mode={mode}
        onHide={(usenavigate=false) => { onHide && onHide(usenavigate); } }
        processId={processId}
        basketData={undefined}   
        Id={Id}
          callAttachmentMoveTemp={callAttachmentMoveTemp}


     />

    }

    </div>
  );
};
